import { useMemo } from "react";
import InvoiceListResponse from "../../models/serviceApi/InvoiceListResponse";
import InvoiceList from "../../models/domain/InvoiceList";
import useRemoteResource from "../remoteResource/useRemoteResource";
import InvoiceListMapper from "../../mappers/InvoiceListMapper";
import Path, { StringMap } from "../../models/ui/Path";
import utils from "../../Utils";
import RemoteResource from "../remoteResource/RemoteResource";
import { getPortal } from "../../portals/portalConfig";

export interface UseInvoiceListOptions {
  /** When set (e.g. CA portal), skips receptionist profile clinic lookup. */
  clinicId?: string | null;
}

export default function useInvoiceList(
  query: StringMap = {},
  options?: UseInvoiceListOptions,
): RemoteResource<InvoiceList> {
  const clinicId =
    options?.clinicId ??
    (getPortal() === "ca" ? null : utils.retrieveUserProfile()?.clinicId);

  const path = useMemo(() => {
    if (!clinicId) return null;

    return new Path(
      ["api", "v1", "users", "invoices", clinicId],
      query,
    ).toString();
  }, [clinicId, query]);

  const { error, isLoading, resource, refresh } =
    useRemoteResource<InvoiceListResponse>(path);

  const mappedResource = useMemo(
    () =>
      resource ? InvoiceListMapper.mapResponseToModel(resource) : undefined,
    [resource],
  );

  return {
    resource: mappedResource,
    isLoading,
    error,
    refresh,
  };
}
